import { render } from "./Instagram.vue?vue&type=template&id=7d3cafb8"
const script = {}
script.render = render

export default script